import React from 'react';

const ThreeDotsCircle = (props) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <rect width="40" height="40" rx="20" fill="#EEEEEE" />
      <path
        d="M20 19C19.4477 19 19 19.4477 19 20C19 20.5523 19.4477 21 20 21C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19Z"
        fill="#3F3C43"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 26C19.4477 26 19 26.4477 19 27C19 27.5523 19.4477 28 20 28C20.5523 28 21 27.5523 21 27C21 26.4477 20.5523 26 20 26Z"
        fill="#3F3C43"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 12C19.4477 12 19 12.4477 19 13C19 13.5523 19.4477 14 20 14C20.5523 14 21 13.5523 21 13C21 12.4477 20.5523 12 20 12Z"
        fill="#3F3C43"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ThreeDotsCircle;
